






















































































































































































































































































































































































































import mixins from 'vue-typed-mixins'
import { UnitValuationStepData } from '@/interfaces/valuation/ValuationData'
import valuationStepMixin from '@/mixins/valuation/valuationStep'
import { PropertyType } from '@/interfaces/valuation/types/PropertyValuationStep'
import * as types from '@/interfaces/valuation/types/UnitValuationStep'
import {
  BuildingStatus,
  BuildingType,
} from '@/interfaces/valuation/types/BuildingValuationStep'
import { VMoney } from 'v-money'

export default mixins(valuationStepMixin).extend({
  directives: {
    money: VMoney,
  },
  data(): { stepData: UnitValuationStepData; BuildingStatus: any } {
    return {
      stepData: {
        unit: {
          apartmentNumber: '',
          apartmentBusinessDesignation: '',
          apartmentLayout: 1,
          apartmentType: types.ApartmentType.Flat,
          apartmentFloor: types.ApartmentFloor.Other,
          apartmentHeating: types.ApartmentHeating.District,
        },
        propertyPrice: 0,
      },
      BuildingStatus,
    }
  },
  computed: {
    buildingStatus(): BuildingStatus {
      return this.$store.getters['valuationProcess/buildingStatus']
    },
    buildingType(): BuildingType {
      return this.$store.getters['valuationProcess/buildingType']
    },
    showUnitReconstruction(): boolean {
      return [BuildingType.Panel, BuildingType.Brick].includes(
        this.buildingType
      )
    },
    moneyFormat() {
      return {
        precision: 0,
        thousands: ' ',
        decimal: ',',
      }
    },
  },
  watch: {
    'stepData.unit.apartmentArea'(val) {
      const unit = this.stepData.unit as types.ApartmentUnit
      if (val <= 41.99) {
        unit.apartmentLayout = 1
      } else if (val <= 66.99) {
        unit.apartmentLayout = 2
      } else if (val <= 86.99) {
        unit.apartmentLayout = 3
      } else if (val <= 121.99) {
        unit.apartmentLayout = 4
      } else {
        unit.apartmentLayout = 5
      }
    },
  },
})
